import { MediaType } from "@/types/media.ts";

/**
 * The keys of this structure are the broad file types we use e.g. "image", "video".
 * The values are arrays of specifier strings.
 * Valid specifiers are here: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#unique_file_type_specifiers
 */
const mediaTypes: Record<MediaType, string[]> = {
  image: [
    "image/png",
    "image/jpeg",
    "image/webp",
    "image/gif",
    "image/tiff",
    "image/svg+xml",
    "image/apng",
    "image/avif",
    "image/heic",
  ],
  video: [
    "video/ogg",
    "video/mp4",
    "video/webm",
    "video/quicktime",
    "video/mov",
  ],
  pdf: ["application/pdf"],
  text: ["text/plain"],
  font: [
    "font/woff",
    "font/woff2",
    "font/ttf",
    "font/otf",
    "application/font-woff",
    "application/font-woff2",
    "application/octet-stream",
    "application/font-sfnt",
    ".woff",
    ".woff2",
    ".otf",
    ".ttf",
  ],
};

function getMediaTypeFromSpecifier(specifier: string): MediaType | undefined {
  const entry = Object.entries(mediaTypes).find((e) =>
    e[1].includes(specifier)
  );

  return entry ? (entry[0] as MediaType) : undefined;
}

export { mediaTypes, getMediaTypeFromSpecifier };
